import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

const getWindowActivityAtom = atomFamily((_windowId: string) =>
  atom({ active: false, inactiveSince: Date.now() }),
);

export default getWindowActivityAtom;
